import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import WelcomeHeader from './components/WelcomeHeader';
import LoginForm from './components/LoginForm';
import SecurityBadges from './components/SecurityBadges';

const LoginPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (credentials) => {
    setIsLoading(true);
    
    try {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      // Mock successful login
      const mockUser = {
        id: 1,
        name: 'Sarah Johnson',
        email: credentials?.email,
        preferences: {
          language: 'en',
          units: 'metric',
          repeatWindow: 3
        }
      };
      
      // Store user data (in real app, this would be handled by auth context)
      localStorage.setItem('currentUser', JSON.stringify(mockUser));
      localStorage.setItem('isAuthenticated', 'true');
      
      // Navigate to dashboard
      navigate('/');
      
    } catch (error) {
      console.error('Login failed:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-card rounded-2xl shadow-warm-lg border border-border p-8">
          <WelcomeHeader />
          <LoginForm onLogin={handleLogin} isLoading={isLoading} />
          <SecurityBadges />
        </div>
        
        {/* Mobile-specific enhancements */}
        <div className="mt-6 text-center sm:hidden">
          <p className="text-xs text-muted-foreground">
            Having trouble signing in? Contact support for assistance.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;